import { unref } from 'vue';

import { useOriginScroll } from '@components/components/CdsTree/components/VirtualList/features/useOriginScroll';
import { wrapperRaf } from '@components/utils';

import type { Ref } from 'vue';

interface FireFoxDOMMouseScrollEvent {
  detail: number;
  preventDefault: Function;
}

const isFF = typeof navigator === 'object' && /Firefox/i.test(navigator.userAgent);

export function useFrameWheel(
  inVirtual: Ref<boolean>,
  isScrollAtTop: Ref<boolean>,
  isScrollAtBottom: Ref<boolean>,
  onWheelDelta: (offset: number) => void
): {
  onWheel: (e: WheelEvent) => void;
  onFireFoxScroll: (e: FireFoxDOMMouseScrollEvent) => void;
} {
  let offsetRef = 0;
  let nextFrame: number | null = null;

  // Firefox patch
  let wheelValue: any = null;
  let isMouseScroll = false;

  // Scroll status sync
  const originScroll = useOriginScroll(isScrollAtTop, isScrollAtBottom);

  function onWheel(event: { preventDefault?: any; deltaY?: any }) {
    if (!unref(inVirtual)) return;

    wrapperRaf.cancel(nextFrame!);

    const { deltaY } = event;
    offsetRef += deltaY;
    wheelValue = deltaY;

    // Do nothing when scroll at the edge, Skip check when is in scroll
    if (originScroll(deltaY)) return;

    // Proxy of scroll events
    if (!isFF) {
      event.preventDefault();
    }

    nextFrame = wrapperRaf(() => {
      // Patch a multiple for Firefox to fix wheel number too small
      const patchMultiple = isMouseScroll ? 10 : 1;
      onWheelDelta(offsetRef * patchMultiple);
      offsetRef = 0;
    });
  }

  // A patch for firefox
  function onFireFoxScroll(event: { detail: any }) {
    if (!inVirtual.value) return;

    isMouseScroll = event.detail === wheelValue;
  }

  return { onWheel, onFireFoxScroll };
}
